/** import external dependencies */
import 'jquery';
import 'bootstrap';
import 'slick-carousel/slick/slick.min';  
import 'velocity-animate/velocity.min.js'; 
import 'jquery-match-height/jquery.matchHeight.js'; 


/** import local dependencies */
import Router from './util/Router'; 
import common from './routes/common';
import home from './routes/home'; 
import blog from './routes/blog'; 
 
/** 
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({ 
  /** All pages */
  common, 
  /** Home page */

  home,
  /** Blog */
  blog, 
}); 

/** Load Events */
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js